import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { groupBy, map } from 'lodash';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PriceAmounts } from '@sm360/widget-commons-general';
import { ModelYear, CurrencyFormats } from '@sm360/widget-commons-vehicle';
import ColorItem from 'build-and-quote/components/ModelTrims/components/ColourItem.jsx';
import 'build-and-quote/components/ModelTrims/modelTrimColours.scss';

/* eslint jsx-a11y/no-static-element-interactions: 0 */

class ModelTrimColours extends Component {
    constructor(props) {
        super(props);

        this.state = {
            exteriorColourHover: undefined,
            interiorColourHover: undefined,
        };

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        this.getColours = this.getColours.bind(this);
        this.getSelectedColour = this.getSelectedColour.bind(this);
    }

    onMouseEnter(colour, colourType) {
        this.setState({
            [`${colourType}Hover`]: colour,
        });
    }

    onMouseLeave(colourType) {
        this.setState({
            [`${colourType}Hover`]: this.getSelectedColour(this.getColours(colourType)),
        });
    }

    getColours(coulourType) {
        return this.props.optionsPackageConfiguration && this.props.optionsPackageConfiguration[coulourType];
    }

    getSelectedColour(colours) {
        return colours && colours.filter((colour) => colour.selected).first();
    }

    render() {
        const {
            exteriorColourImageServerDomain,
            interiorColourImageServerDomain,
            onExteriorColourClick,
            onInteriorColourClick,
        } = this.props;

        const exteriorColours = this.getColours('exteriorColours');

        const selectedExteriorColour = this.getSelectedColour(exteriorColours);

        const interiorColours = this.getColours('interiorColours');

        const selectedInteriorColour = this.getSelectedColour(interiorColours);

        const interiorColoursFabrics = interiorColours && groupBy(interiorColours.toJS(), 'fabricDescription');

        const exteriorColourSection = exteriorColours ? (
            exteriorColours.map((colour) => (
                <ColorItem
                    key={colour.colourCode}
                    colour={colour}
                    onClick={onExteriorColourClick}
                    onMouseEnter={() => this.onMouseEnter(colour, 'exteriorColour')}
                    onMouseLeave={() => this.onMouseLeave('exteriorColour')}
                    colourImageServerDomain={exteriorColourImageServerDomain}
                />
            ))
        ) : (
            <li />
        );

        function hasEnabledColor(fabricSection) {
            if (!fabricSection) {
                return false;
            }
            return fabricSection.reduce((previous, colour) => {
                return previous || colour.enabled;
            }, false);
        }

        const interiorFabricsSection =
            interiorColoursFabrics &&
            map(
                interiorColoursFabrics,
                (colours, fabric) =>
                    hasEnabledColor(colours) && (
                        <div className="style-color__interiorColor" key={fabric}>
                            <p className="style-color__label">{fabric}</p>
                            <ul key={fabric} id={fabric} className="clearfix style-color__colorList">
                                {colours.map((colour) => (
                                    <ColorItem
                                        key={colour.colourCode}
                                        colour={colour}
                                        onClick={onInteriorColourClick}
                                        onMouseEnter={() => this.onMouseEnter(colour, 'interiorColour')}
                                        onMouseLeave={() => this.onMouseLeave('interiorColour')}
                                        colourImageServerDomain={interiorColourImageServerDomain}
                                    />
                                ))}
                            </ul>
                        </div>
                    )
            );

        const colourDescription = (colour) => {
            if (!colour) {
                return null;
            }
            const price = colour.retail > 0 && (
                <span className="is-price sr-disclaimer">
                    (+ <PriceAmounts price={LocaleService.l(colour.retail, CurrencyFormats.CURRENCY_0)} />)
                </span>
            );
            return (
                <div>
                    <span className="is-light sr-disclaimer">{colour.colourDescription}</span>
                    {price}
                </div>
            );
        };

        return (
            <section className="style-color">
                <div className="bloc-container-wrapper style-color-wrapper">
                    <div className="style-color__exterior">
                        <div className="style-color__row-top">
                            <p className="style-color__label sr-subtitle-2">
                                {LocaleService.t('modelTrimSection.EXTERIOR_LABEL')}
                                {this.state.exteriorColourHover
                                    ? colourDescription(this.state.exteriorColourHover)
                                    : colourDescription(selectedExteriorColour)}
                            </p>
                        </div>
                        <div className="style-color__row-bottom">
                            <div>
                                <p className="style-color__label">
                                    {LocaleService.t('modelTrimSection.EXTERIOR_COLOUR')}
                                </p>
                                <ul className="clearfix style-color__colorList">{exteriorColourSection}</ul>
                            </div>
                        </div>
                    </div>
                    <div className="style-color__interior">
                        <div className="style-color__row-top">
                            <p className="style-color__label sr-subtitle-2">
                                {LocaleService.t('modelTrimSection.interiorLabel')}
                                {this.state.interiorColourHover
                                    ? colourDescription(this.state.interiorColourHover)
                                    : colourDescription(selectedInteriorColour)}
                            </p>
                        </div>
                        <div className="style-color__row-bottom">{interiorFabricsSection}</div>
                    </div>
                </div>
            </section>
        );
    }
}

ModelTrimColours.propTypes = {
    exteriorColourImageServerDomain: PropTypes.string.isRequired,
    interiorColourImageServerDomain: PropTypes.string.isRequired,
    onExteriorColourClick: PropTypes.func.isRequired,
    onInteriorColourClick: PropTypes.func.isRequired,
    optionsPackageConfiguration: PropTypes.instanceOf(ModelYear.ModelTrimConfigurationModel).isRequired,
};

ModelTrimColours.displayName = 'ModelTrimColours';

export default ModelTrimColours;
